import { GoogleAnalyticsI, AnyStringToNumberI } from './';

export const mockGoogleAnalyticsSource: AnyStringToNumberI = {
  '(direct) / (none)': 174,
  'baidu.com / referral': 2,
  'bing / organic': 11,
  'facebook.com / referral': 83,
  'google / cpc': 132,
  'google / organic': 110,
  'homeaddict.io / referral': 1,
  'instagram.com / referral': 5,
  'l.facebook.com / referral': 42,
  'lm.facebook.com / referral': 2,
  'm.facebook.com / referral': 1061,
  'review.intern.facebook.com / referral': 1,
  'secureurl.ukr.net / referral': 1,
  'stlmag.com / referral': 1,
  'stlouishomesmag.com / referral': 1,
  'top5.com / referral': 1,
  'yahoo / organic': 2,
};

export const mockGoogleAnalyticsData: GoogleAnalyticsI = {
  medium: {
    adwords: 0,
    'not provided': 0,
    organic: 0,
    referral: 0,
  },
  source: mockGoogleAnalyticsSource,
  audience: {
    avgSessionDuration: 0,
    bounceRate: 0,
    newUsers: 0,
    pageViews: 0,
    pageViewsPerSession: 0,
    returningUsers: 0,
    sessions: 0,
    sessionsPerUser: 0,
    uniquePageViews: 0,
    users: 0,
  },
  tableData: [
    {
      avgTimeOnPage: 0,
      bounceRate: 0,
      entrances: 0,
      exitRate: 0,
      name: '',
      pageViews: 0,
      uniquePageViews: 0,
    },
  ],
  usersByAge: {
    '18-24': 0,
    '25-34': 0,
    '35-44': 0,
    '45-54': 0,
    '55-64': 0,
    '65+': 0,
  },
  usersByGender: {
    male: 0,
    female: 0,
    other: 0,
  },
  rows: [
    {
      avgTimeOnPage: 0,
      bounceRate: 0,
      entrances: 0,
      exitRate: 100,
      name: '/mock-url',
      pageViews: 1,
      uniquePageviews: 1,
    },
  ],
};
